import React from 'react';
import { CalculatorVideo } from '../CalculatorVideo';
import { CalculatorForm } from '../CalculatorForm';
export function CalculatorHero() {
  return <div className="bg-white w-full py-10 md:py-16" data-id="element-94">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8" data-id="element-95">
        <div className="mb-8 text-center" data-id="element-96">
          <p className="text-[20px] md:text-[24px] font-bold text-[#00be60] mb-2" data-id="element-97">
            FREE CALCULATOR DOWNLOAD:
          </p>
          <h1 className="text-[28px] md:text-[42px] font-bold text-black mb-4" data-id="element-98">
            See What It Costs To Build A Proprietary Deal Flow Pipeline Using
            Meta Ads
          </h1>
          <p className="text-[16px] md:text-[18px] text-[#666666] max-w-3xl mx-auto mb-8" data-id="element-99">
            Watch this demo to calculate your exact advertising costs for
            sourcing qualified off-market seller leads (vs. traditional broker
            fees)
          </p>
        </div>
        {/* Mobile: Video above form */}
        <div className="lg:hidden flex flex-col" data-id="element-100">
          <div className="w-full mb-8" data-id="element-101">
            <CalculatorVideo data-id="element-102" />
          </div>
          <div className="w-full" data-id="element-103">
            <div className="bg-white rounded-xl p-0" id="calculator-form-mobile" data-id="element-104">
              <h3 className="text-[18px] md:text-[20px] font-bold text-black mb-4 text-center" data-id="element-105">
                Get The Interactive Deal Flow Cost Calculator
              </h3>
              <CalculatorForm data-id="element-106" />
            </div>
          </div>
        </div>
        {/* Desktop: Centered video with form and content below */}
        <div className="hidden lg:block" data-id="element-107">
          {/* Centered larger video */}
          <div className="w-full max-w-4xl mx-auto mb-16" data-id="element-108">
            <CalculatorVideo data-id="element-109" />
          </div>
        </div>
      </div>
    </div>;
}